// extracted by mini-css-extract-plugin
export default {"text":"HintTakeIt_text__7oTuG"};